import { Component, Input } from "@angular/core";

@Component({
    standalone: true,
    selector: 'gene-help-icon',
    templateUrl: './help-icon.component.html',
    styleUrls: ['./help-icon.component.css']
})
export class HelpIconComponent {
    @Input() width!: string;
    @Input() height!: string;
    @Input() color!: string;
    // TODO: Need to implement tooltip directive into library
    @Input() helpText?: string = '';
};
